import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./components/website/Home";
import Dashboard from "./components/website/DashBoard";
import ResetPassword from "./components/website/ResetPassword";
import './styles/slick.css';
import './styles/global.css'; // ← your design variables

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
